
module.exports = {
    TABLE:          'table',
    HEADER:         'table-header',
    BODY:           'table-body',
    ROW:            'table-row',
    CELL:           'table-cell'
};
